import {
  getDetails,
  remove,
  setShowLoader,
  setHideLoader
} from 'src/core/redux/actions';
import { Access, User, UserType } from 'src/core/models';
import LocalStorageService from 'src/core/services/LocalStoregeService';

export const fetchAccessAndUserData = () => async (dispatch) => {
  await dispatch(setShowLoader());

  const response = await dispatch(getDetails(Access)({}));

  if (!response.shouldRedirect) {
    const userType = await dispatch(getDetails(UserType)({}));

    if (userType.data && !userType.data?.isAnonymous) {
      await dispatch(getDetails(User)());
    }
  }

  await dispatch(setHideLoader());
};

export const resetUserDetails = () => (dispatch) => {
  dispatch(remove(UserType.NAME, 'details'));
  dispatch(remove(User.NAME, 'details'));

  LocalStorageService.removeItem('loggedUser');
};
